export const ToolType = {
  Files: 'files',
  Workspace: 'workspace'
} as const;
export type ToolTypeValue = typeof ToolType[keyof typeof ToolType];

export const ToolName = {
  NumberOfColumns: 'number_of_columns',
  Tags: 'tags',
  Colors: 'colors',
  AdditionalBatchesOnly: 'additional_batches_only',
  HaveDuplicateInWorkspace: 'have_duplicate_in_workspace',
  GoToPage: 'go_to_page',
  GoToLastOpenedPage: 'go_to_last_opened_page',
  GoToPostEvent: 'go_to_post_event',
  EpisodeTypes: 'episode_types',
  EpisodeLabels: 'episode_labels',
  EpisodeAuthors: 'episode_authors',
  ExportPagesToPDF: 'export_pages_to_pdf',
  SendToAIChat: 'send_to_ai_chat',
  PagesInWorkspace: 'pages_in_workspace',
  WorkspaceViewMode: 'workspace_view_mode'
} as const;
export type ToolNameValue = typeof ToolName[keyof typeof ToolName];